import { useUpdateWindowType, usePageViewEvent } from 'common/hooks';

export const useCataloguePage = () => {
	useUpdateWindowType();
	usePageViewEvent();
};
